export const currentTotalToPercentage = (current, total) =>
  (current * 100) / total
